import { useMemo, useState } from 'react';
import { getFeePrice } from 'lib/util';

type Fee = {
  baseFee: number | null;
  eventFee: number | null;
};

type Fees = {
  playdapp: Fee;
  developer: Fee;
};

const useFeeValues = (fee: Fees, originPrice = '') => {
  const [price, setPrice] = useState(originPrice);

  const feeValues = useMemo(() => {
    const playdappFee = fee?.playdapp?.baseFee
      ? fee?.playdapp?.baseFee / 100
      : 0;
    const developerFee = fee?.developer?.baseFee
      ? fee?.developer.baseFee / 100
      : 0;
    const totalFee = Number(playdappFee) + Number(developerFee);

    return {
      playdapp: {
        price: getFeePrice(price, playdappFee),
        percent: playdappFee,
      },
      developer: {
        price: getFeePrice(price, developerFee),
        percent: developerFee,
      },
      total: {
        price: getFeePrice(price, totalFee),
        percent: totalFee,
      },
    };
  }, [fee, price]);

  const handleUpdatePrice = (price: string) => {
    setPrice(price);
  };

  return { feeValues, handleUpdatePrice };
};

export default useFeeValues;
